import { Action, createReducer, on } from '@ngrx/store';
import { ErrorResponse, IGenericError } from '../../../core/models/generic-models';
import { fromCreateBusinessActions } from '../actions';
import { ICreateBusinessRequest, ICreateBusinessResponse } from '../models/create-business.model';

export const createBusinessFeatureKey = 'createBusiness';

export interface CreateBusinessState {
  newBusinessRequest: ICreateBusinessRequest;
  newBusinessResponse: string;
  newBusinessFailure: IGenericError<ErrorResponse>;
}

export const initialState: CreateBusinessState = {
  newBusinessRequest: undefined,
  newBusinessResponse: undefined,
  newBusinessFailure: undefined
};

export const reducer = createReducer(
  initialState,

  on(fromCreateBusinessActions.loadCreateBusiness, (state, action) => ({
    ...state,
    newBusinessRequest: action.request,
    loaded: true
  })),
  on(fromCreateBusinessActions.loadCreateBusinessSuccess, (state, action) => ({
    ...state,
    newBusinessResponse: action.response
  })),
  on(fromCreateBusinessActions.loadCreateBusinessFailure, (state, action) => ({
    ...state,
    newBusinessFailure: action.error
  }))
);

export const getCreateBusinessRequest = (state: CreateBusinessState) => state.newBusinessRequest;
export const getCreateBusinessResponse = (state: CreateBusinessState) => state.newBusinessResponse;
export const getCreateBusinessFailure = (state: CreateBusinessState) => state.newBusinessFailure;
